const message = {
  more: "更多",
};

export default message;
